import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "../components/sidebar/sidebar";
import { Navbar } from "../components/navbar/navbar";

const DashboardLayout: React.FC = () => {
  const [searchQuery, setSearchQuery] = useState("");

  const handleSearch = (query: string) => {
    setSearchQuery(query);
  };

  return (
    <div className="flex">
      <Sidebar />
      <div className="w-full md:w-3/4 lg:w-5/6 h-full">
        <Navbar onSearch={handleSearch} />
        <Outlet context={{ searchQuery }} />
      </div>
    </div>
  );
};

export default DashboardLayout;
